import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  template: `
    <mat-dialog-content>
      <h5>Excluir {{ data.nomeEntidade }}</h5>
      <p>
        Deseja excluir a(o) {{ data.nomeEntidade }}
        {{ data.descricaoEntidade }} ?
      </p>
    </mat-dialog-content>

    <div matDialogActions class="w-100 d-flex justify-content-between">
      <button
        [matDialogClose]="false"
        id="denny-btn"
        mat-stroked-button
        color="primary"
        type="button"
      >
        Cancelar
      </button>
      <button
        [matDialogClose]="true"
        id="confirm-btn"
        mat-flat-button
        color="primary"
        type="submit"
      >
        Confirmar
      </button>
    </div>
  `
})
export class DialogDelContatoComponent {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      nomeEntidade: string;
      descricaoEntidade: string;
    }
  ) {}
}
